import moment from "moment";
import { getDateFromDatepicker } from "./dates";

export function sortOnCreatedAt(a, b) {
  if (moment(a.created_at).isBefore(b.created_at, "day")) {
    return -1;
  }

  if (moment(a.created_at).isAfter(b.created_at, "day")) {
    return 1;
  }

  return 0;
}

export function sortOnCreatedAtDatepicker(a, b) {
  const first = getDateFromDatepicker(a.created_at, true);
  const second = getDateFromDatepicker(b.created_at, true);

  if (moment(first).isBefore(second, "day")) {
    return -1;
  }

  if (moment(first).isAfter(second, "day")) {
    return 1;
  }

  return 0;
}

export function sortBiletFormFines(object) {
  let tempArray = [];
  let tempObject = {};

  for (let key in object) {
    tempArray.push({ idKeyTemp: key, ...object[key] });
  }
  tempArray.sort(sortOnCreatedAtDatepicker);

  for (let item of tempArray) {
    const { idKeyTemp, ...valuesObject } = item;
    tempObject[idKeyTemp] = valuesObject;
  }

  tempArray = [];
  return tempObject;
}

export function sortFilialPercentsOnPriority(a, b) {
  if (a.priority < b.priority) {
    return -1;
  }

  if (a.priority > b.priority) {
    return 1;
  }

  return 0;
}
